module.exports = __webpack_public_path__ + "img/folder-icon.2cc69ff5.svg";